<template>
  <div class="submain__terrenos-custom">
    <div class="line__vertical-mains"></div>
    <sub-header :micrositeUrl="micrositeUrl" />
    <div v-if="locations.length > 0" class="map_filter">
      <div class="select__box box-terrenos">
         <Range class="ranges-mobile" v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
        <Availables
            class="availables-mobile"
            :type="type"
            :amountAvailables="amountAvailables"
        />
      </div>
      <div class="maphighlight__box">
          <h1 class="caption__select">
                  <span>Seleccione una terreno, clic para ver detalles</span>
                </h1>
        <map-highlight  v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img"  :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel" :indicatorClubGolf="indicatorClubGolf"/>
        <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img"/>
        <div class="line_horizontal ranges-desk"></div>
        
      </div>
      <div class="select__box">
        <!-- <Select
            v-if="locations.length > 0 && rangeFilter.length > 0"
            :locations="locations"
            @change="changeRange"
            :rangeFilter="rangeFilter"
        /> -->
        <Availables
            class="availables-desk"
            :type="type"
            :amountAvailables="amountAvailables"
        />
        <Range class="ranges-desk" v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../core/SubHeader.vue";
import MapHighlight from "../../core/MapHighlight.vue";
//import Select from "../../core/Select.vue";
import Availables from "../../core/Availables.vue";
import Button from "../../core/Button.vue";
import Range from "../../core/Range.vue";
export default {
  name: "Main",
  components: {
    SubHeader,
    MapHighlight,
    /* Select, */
    Availables,
    Button,
    Range
  },
  data() {
    let img = '';
    //let img = this.$route.params.idLocation === '89' ? "https://d2xpezm1ws1jvl.cloudfront.net/masterplan-dashboard/imgs/clubdegolf/preClubGolfERM2024.webp" : 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/clubdegolf/PreClubGolfV2.png'
    if (this.$route.params.idLocation === '89') {
      img = 'https://d2xpezm1ws1jvl.cloudfront.net/masterplan-dashboard/imgs/clubdegolf/preClubGolfERM2024.webp';
    } else if (this.$route.params.idLocation === '310') {
      img = 'https://d2xpezm1ws1jvl.cloudfront.net/masterplan-dashboard/imgs/clubdegolf/preClubGolD13.webp';
    } else {
      img = 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/clubdegolf/PreClubGolfV2.png';
    }
    //consulta los niveles de terreno de una torre etapa: https://gn3bbxdche.execute-api.us-west-2.amazonaws.com/Production/api/towerStageLevels/89

    let rangesSliderToSend = [];
    let rangesPricesToSend = [];
    //Desarollo 52 tiene torre etapa 84=ETAPA 3 (Niveles=234,235 y 236), 85=SECCION TGB Y H (Nivel=275), 89=TRES MARIAS ERM (Nivel=274) y 93=SECCION D13 (Nivel=310)
    if (this.$route.params.idLocation === '89') {
      //clave de terreno 274 torre etapa 89 Sección C38 antes B2-B3
      rangesSliderToSend = [1295, 2366];
      rangesPricesToSend = [8856796, 10938802];
    } else if (this.$route.params.idLocation === '310') {
      //clave de terreno 310 torre etapa 93 sección D13
      rangesSliderToSend = [1333, 5160];
      rangesPricesToSend = [7000000, 18000000];
    } else {
      //clave de terreno 234,235 y 236 torre etapa 84 ERM, B, G y H
      rangesSliderToSend = [903, 10444];
      rangesPricesToSend = [3500000, 12325000];
    }
    return {
      id_location_selected: this.$route.params.idLocation,
      id: 52,
      levelId: 0,
      type: "terreno",
      desarrollo: "canadas_terrenos-priv",
      arrFilteredLocations: [],
      nivel: "availability",
      url: "detalles",
      micrositeUrl: "https://www.tresmarias.com.mx/clubdegolf/terrenos",
      imgSet: [
        {
          name: 'clubdegolf',
          url: img ,
          width: '5647',
          height: '3142',
          id: 52,
          route: '/detalles',
          nivel: 'availability',
          levelId: 0,
          transform: '',
          viewBox: '0 0 5647 3142'
        }
      ],
      // si no hay filtro volver rangeFilter a false
      //rangeSliderFilter:[960,11315],
      //rangeFilterPrice:[2000000,13051000],
      rangeSliderFilter:rangesSliderToSend,
      rangeFilterPrice:rangesPricesToSend,
      rangeFilter: [
        { min: 290, max: 366 },
        { min: 361.1, max: 665 },
        { min: 1400, max: 3680 },
      ],
      indicators: [
                { id: 0, text: 'MANZANA H', transform: 'translate(3640.74 2195.25)', cxB: 3533.13, cyB: 2167.5, rB: 55.58, cxW: 3533.13, cyW: 2167.5, rW: 30.29, x1: 2671.34, y1: 2167.5, x2: 3503.01, y2: 2167.5, status: true },
                //
            ],
    };
  },

  computed: {
    ...mapGetters({
      locations: "getLocations",
    }),
    development() {
      const idLocation = this.$route.params.idLocation;

      // Establecer `level` y `aux` según el valor de `idLocation`
      let level = 235;  // Valor por defecto
      let aux = 236;    // Valor por defecto

      if (idLocation === '89') {
        level = 274;
        aux = 0;
      } else if (idLocation === '310') {
        level = 310;
        aux = 310;
      }

      return { id: 52, level, aux };
    },
    indicatorClubGolf() {
      // Si idLocation es diferente de '89', devuelve indicators; de lo contrario, devuelve undefined
      return (this.$route.params.idLocation !== '89' && this.$route.params.idLocation !== '310') ? this.indicators : undefined;
    },
    amountAvailables() {
      const filteredAvailables = this.existFilter;
      const newArrfiltered = filteredAvailables.filter(
          (item) => item.status == 2
      );
      //console.log(newArrfiltered);
      return newArrfiltered;
    },
    existFilter() {
      let arrExistFilter;
      if (this.rangeFilter) {
        arrExistFilter = this.arrFilteredLocations;
      } else if (this.rangeFilter === false) {
        arrExistFilter = this.locations;
      }
      // Filtrar para que solo queden IDs únicos
      const seenIds = new Set();
      const uniqueArr = [];

      for (const item of arrExistFilter) {
        if (!seenIds.has(item.id)) {
          seenIds.add(item.id);
          uniqueArr.push(item);
        }
      }

      return uniqueArr;
    },
  },
  methods: {
    ...mapActions(["getAvailableLocations", "clearCoords"]),
    changeRange(arrFilter) {
      this.arrFilteredLocations = arrFilter;
    },
  },
  async created() {
    await this.clearCoords();
    await this.getAvailableLocations(this.development);
  },
  async beforeDestroy(){
    await this.clearCoords()
  }
};
</script>